export default {
    taxes_list: null,
    tax_categories_list: []
};
